import { useTranslation } from 'react-i18next'
import React from 'react'

import Tag from '../../../../../packages/kiti/components/presentation/Tag'

const WebhookCallStatus = ({ status }) => {
  const { t } = useTranslation('webhook')
  let label = t('statusCalled')
  let color = 'darkGrey'

  switch (status) {
    case 'error':
      label = t('statusError')
      color = 'lightRed'
      break

    case 'done':
      label = t('statusSuccess')
      color = 'green'
      break
  }

  return <Tag label={label} color={color} size="small" />
}

export default WebhookCallStatus
